import { useFlowsSelector } from '../../../../../../common/src/utils/globalVariables';
import useCurrentGroupPosition from '../../../../hooks/useCurrentGroupPosition';
import { FlowsQuestionGroup } from '../../../../types/FlowsTypes';

const useCurrentGroups = (): FlowsQuestionGroup[] => {
  const flowsPosition = useCurrentGroupPosition();

  const currentGroup = useFlowsSelector(
    (state) => state.flows.questionnaire.groups[flowsPosition],
  );

  return currentGroup?.groups || [];
};

export default useCurrentGroups;
